<template>
    <transition name="fade" mode="out-in">
        <div v-if="scopes.length === 0" key="skeleton">
            <random-form-skeleton/>
        </div>

        <div v-else key="forms">
            <div v-for="scope in scopes" :key="scope.scopeData.code" class="mb-4">
                <h4 class="h4 pb-2">{{ scope.scopeData.title }}</h4>
                <children
                    v-if="scope.scopeData.code === 'children'"
                    :should-notify="true"
                />
                <dynamic-profile-form
                    v-else
                    :form="scope.scopeData.fields"
                    :should-notify="shouldNotify"
                    :identifier="scope.scopeData.code"
                    :subtitle="scope.scopeData.subtitle"
                    :description="scope.scopeData.description"
                    @onSubmitSuccess="(context) => $emit('onSubmitSuccess', context)"/>
            </div>
        </div>
    </transition>
</template>

<script>
import DynamicProfileForm from "./DynamicProfileForm";
import Children from "./Children";
import RandomFormSkeleton from "../../molecules/form/RandomFormSkeleton";

export default {
    name: "DynamicFormContainer",
    components: {RandomFormSkeleton, Children, DynamicProfileForm},
    props: {
        shouldNotify: {
            type: Boolean,
            required: true
        },
        scopes: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>